<div class="app-container">
    <!-- <div *ngIf="bannerHtml" [innerHTML]="bannerHtml" class="broadcast-banner" [ngStyle]="bannerStyles"></div> -->
    <div *ngIf="bannerHtml && (isOnLoginPage() || isOnReservationsPage())" class="broadcast-banner" [ngStyle]="bannerStyles">
        <div [innerHTML]="bannerHtml"></div>
    
        <!-- CTA Button -->
        <a *ngIf="bannerCta && bannerUrl" [href]="bannerUrl" target="_blank" rel="noopener noreferrer"
            class="broadcast-cta-btn">
            {{ bannerCta }}
        </a>
    </div>
    <header *ngIf="!isOnLoginPage() && ready" (swipe)="swipeEnded($event)" class="header">
        <div class="container p-2">
            <button
                *ngIf="!isOnReservationPage() && !isOnWalkinPage() && !isOnGlobalSearchPage() && !isOnSettingsPage() && !editMode"
                class="btn-header-menu-toggle btn-toggler">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28,10H4A1,1,0,0,1,4,8H28a1,1,0,0,1,0,2Z" />
                    <path d="M28,17H4a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z" />
                    <path d="M28,24H4a1,1,0,0,1,0-2H28a1,1,0,0,1,0,2Z" />
                </svg>
            </button>
            <div *ngIf="(reservationsIsActive.isActive || blockingIsActive.isActive || tablesPlanIsActive.isActive) && (date$ | async) as date"
                class="d-flex ml-sm-2">
                <app-datepicker [model]="date" (modelChange)="dateChange($event)"
                    [disabled]="isOnTablesPlanPage() && (editMode || selectedTables.length > 0 || reservationAssignTablesMode || addJoinedTablesMode)"></app-datepicker>
                <a class="today-btn btn btn-sm btn-main ms-3 d-flex align-items-center"
                    [class.selected]="isTodaySelected()" [class.disabled]="disableMenuItems()" (click)="today()">{{
                    'common.today' | translate }}</a>
                <!-- <a class="btn btn-sm btn-main ms-3 d-flex align-items-center"
                    (click)="downloadApk()">Download.apk</a> -->
            </div>

            <!-- tables plan -->
            @if (isOnTablesPlanPage() && (date$ | async)) {
            <div class="d-flex">
                <!-- @if (editMode) {
                <a class="btn btn-sm btn-main ms-3 px-2" (click)="setTablesPlanMode(false)" [class.disabled]="disableMenuItems()">
                    {{ 'tablesPlan.header.backButton' | translate }}
                </a>
                } @else { -->
                <a [canWrite]="'EditTablesPlanPocket'" class="btn btn-sm btn-main ms-3 px-2" (click)="setTablesPlanMode(true)" [class.disabled]="disableMenuItems()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                    </svg>
                </a>
                <!-- } -->

                <!-- shifts -->
                @if (selectedShift != null) {
                <div class="shifts-dropdown dropdown ihost-dropdown h-100">
                    <a id="selected-shift" class="btn btn btn-main ms-3 px-2" href="#" role="button"
                        data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false"
                        [class.disabled]="disableMenuItems()">
                        <span class="shift-name">{{getShiftTitle(selectedShift.type)}}</span>
                        <span class="shift-hours">{{selectedShift | shiftFromToHour}}</span>
                    </a>
                    <div class="dropdown-menu tables-plan-shifts-menu p-0 border-0 shadow-none">
                        @for (shift of processedShifts; track shift.shiftId) {
                        <a class="btn btn-sm py-1 px-2 text-nowrap d-flex justify-content-between"
                            (click)="selectTablesPlanShift(shift)">
                            <span class="shift-name">{{getShiftTitle(shift.type)}}</span>
                            <span class="shift-hours">{{shift | shiftFromToHour}}</span>
                        </a>
                        }
                    </div>
                </div>
                }

            </div>
            }

            <ng-container
                *ngIf="isOnReservationPage() || isOnWalkinPage() || isOnGlobalSearchPage() || isOnSettingsPage()">
                <a class="btn btn-transparent px-1" (click)="goBack()"><i class="ihost-icon-back"></i> {{ 'menu.back' |
                    translate }}</a>
            </ng-container>
            <div class="ms-auto">
                <div *ngIf="isOnReservationsPage() || isOnBlockingPage()" class="">
                    <a [canWrite]="'AddWalkIn'" class="btn btn-main px-3" routerLink="/walkin/add"
                        [class.disabled]="disableCreateReservationButtons()"><i class="ihost-icon-walkin"></i></a>
                    <a [canWrite]="'AddReservation'" class="btn btn-main ms-2 px-3" routerLink="/reservations/add"
                        [class.disabled]="disableCreateReservationButtons()"><i class="ihost-icon-reservation"></i></a>
                </div>
                <a *ngIf="!readOnlyMode && isOnReservationPage()" class="btn btn-main"
                    (click)="alreadyReservedTablesExist()" [class.disabled]="isSubmiting">{{
                    'menu.submitReservation' | translate }}</a>
                <a *ngIf="!readOnlyMode && isOnWalkinPage()" class="btn btn-main"
                    (click)="alreadyReservedTablesExist()" [class.disabled]="isSubmiting">{{
                    'menu.submitWalkIn' |
                    translate }}</a>
                <a *ngIf="!readOnlyMode && isOnReportsPage() && utilsService.getPlatform() == 'web'"
                    class="btn btn-remove" [canWrite]="'ReportsDashboard'" (click)="goToDashboard()">{{
                    'menu.reportsDashboard' |
                    translate }}</a>
                <a *ngIf="isOnSettingsPage()" class="btn btn-main" (click)="submitSettings()">{{
                    'menu.submitSettings' | translate }}</a>
            </div>
            <div class="top-header-menu">
                <!-- <button class="btn-toggler btn-header-menu-close">&times;</button> -->
                <div class="top-header-bg">
                </div>
                <div class="top-header-container">
                    <div class="d-flex align-items-center mb-4">
                        <h3 class="mb-0"><small>{{ 'menu.welcome' | translate }}</small> {{activeUser}}</h3>
                        <a (click)="sync()" class="btn btn-sm btn-transparent-outline text-link px-2 ml-auto">{{
                            'menu.sync' | translate }}</a>
                    </div>
                    <app-dropdown *ngIf="restaurants != null && restaurants.length > 0"
                        (onChange)="restaurantChanged($event)" [(model)]="activeRestaurant" [items]="restaurants"
                        [displayProperty]="'display'" [valueProperty]="'value'" [readonly]="isOffline">
                    </app-dropdown>
                    <ul class="top-menu-nav">
                        <li routerLinkActive="active" #reservationsIsActive="routerLinkActive"
                            [routerLinkActiveOptions]="{exact: true}">
                            <a (click)="closeMenu()" routerLink="/reservations">{{ 'menu.reservationsMi' | translate
                                }}</a>
                            <a style="display: none" routerLink="/">{{ 'menu.reservationsMi' | translate }}</a>
                        </li>

                        <li [canWrite]="'TablesPlanPocket'" routerLinkActive="active"
                            #tablesPlanIsActive="routerLinkActive"><a (click)="closeMenu()" routerLink="/tables-plan">
                                <span>{{ 'menu.tablesPlan' | translate }}</span>
                                @if (!hasOpenedTablesPlan) {
                                <span class="btn-msg btn btn-sm ms-2 py-0 px-2 btn-remove">{{ 'common.new' | translate
                                    }}</span>
                                }
                            </a>
                        </li>

                        <li [canWrite]="'CheckBlocking'" routerLinkActive="active" #blockingIsActive="routerLinkActive"
                            [routerLinkActiveOptions]="{exact: true}">
                            <a (click)="closeMenu()" routerLinkActive="active" routerLink="/blocking">{{
                                'menu.blockingMi' |
                                translate }}</a>
                        </li>
                        <li [canWrite]="'visits_report_overview'" *ngIf="!isOffline"><a (click)="closeMenu()"
                                routerLinkActive="active" routerLink="/reports">{{ 'menu.reportsMi'
                                |
                                translate }}</a></li>
                        <li *ngIf="!isOffline  && false"><a (click)="closeMenu()" routerLinkActive="active"
                                routerLink="/dietary-tags">{{
                                'menu.dietaryMi'
                                | translate }}</a>
                        </li>
                        <li [canWrite]="'ManageTags'" *ngIf="!isOffline && showTags"><a (click)="closeMenu()"
                                routerLinkActive="active" routerLink="/reservation-tags">{{
                                'menu.reservationTagsMi' | translate }}</a></li>
                        <li [canWrite]="'ManageTags'" *ngIf="!isOffline && showTags"><a (click)="closeMenu()"
                                routerLinkActive="active" routerLink="/customer-tags">{{
                                'menu.customerTypesMi' | translate }}</a></li>
                        <li [canWrite]="'ManageUsers'" *ngIf="!isOffline && showUsers"><a (click)="closeMenu()"
                                routerLinkActive="active" routerLink="/users">{{
                                'menu.employeesMI' | translate }}</a></li>
                        <li *ngIf="!isOffline && false"><a (click)="closeMenu()" routerLinkActive="active"
                                routerLink="/sources">{{ 'menu.sourcesMi'
                                |
                                translate }}</a></li>
                        <li *ngIf="!isOffline" [canWrite]="'GoToAdminPanel'"><a (click)="goToAdminPanel()">{{
                                'menu.goToAdminPanel' | translate }}</a></li>

                        <li *ngIf="!isOffline && isWebPlatform()" [canWrite]="'GoToMarketingTool'">
                            <a (click)="goToMarketingTool()">
                                {{ 'menu.goMarketingTool' | translate }}
                            </a>
                        </li>

                        <li><a (click)="help()">{{ 'menu.help' | translate }}</a></li>

                        <li *ngIf="advertisment != null"><a (click)="closeMenu(); showAds(100)">
                                {{'menu.ads' | translate }}</a></li>

                        <li><a (click)="showSettingsModal()" routerLinkActive="active">{{
                                'menu.settingsForm' | translate }}</a></li>

                        <li [canWrite]="'exportReservationsList'" *ngIf="isOnReservationsPage()" ><a (click)="showReservationsExportModal()" routerLinkActive="active">{{
                                'reservationsExport.export' | translate }}</a></li>

                        <li><a (click)="closeMenu()" routerLinkActive="active" routerLink="/settings">{{
                                'menu.settings' | translate }}</a></li>

                        <li><a (click)="logout($event)">{{ 'menu.logoutMi' | translate }}</a></li>
                    </ul>
                </div>
            </div>
            @if (isOnTablesPlanPage() && (date$ | async)) {
            <div class="d-flex">

                @if (!editMode) {
                <a [canWrite]="'AddWalkIn'" class="btn btn-main ms-r px-2" href="javascript:void(0);" role="button"
                    (click)="addWalkIn()" [class.disabled]="disableCreateReservationButtons()">
                    <app-icon icon="MenuItemWalk"></app-icon>
                </a>
                <a [canWrite]="'AddReservation'" class="btn btn-main ms-r px-2" href="#" role="button"
                    routerLink="/reservations/add" [class.disabled]="disableCreateReservationButtons()">
                    <app-icon icon="MenuItemR"></app-icon>
                </a>
                } @else {
                    @if (editingTable == null && !addJoinedTablesMode) {
                        <!-- <a class="btn btn-sm btn-success d-flex align-items-center ms-r px-2" (click)="saveTablesPlan()">
                            <svg id="vector" xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 27 28">
                                <path fill="#f8f8f8"
                                    d="M23.148,8.13L18.978,3.96C18.9,3.882 18.808,3.821 18.706,3.78C18.604,3.738 18.495,3.717 18.386,3.718H5.04C4.598,3.718 4.174,3.894 3.861,4.206C3.548,4.519 3.372,4.944 3.372,5.386V22.068C3.372,22.51 3.548,22.934 3.861,23.247C4.174,23.56 4.598,23.736 5.04,23.736H21.722C22.164,23.736 22.589,23.56 22.902,23.247C23.214,22.934 23.39,22.51 23.39,22.068V8.722C23.391,8.613 23.37,8.504 23.328,8.402C23.287,8.3 23.226,8.208 23.148,8.13ZM10.045,5.386H16.718V8.722H10.045V5.386ZM16.718,22.068H10.045V15.395H16.718V22.068ZM18.386,22.068V15.395C18.386,14.953 18.21,14.528 17.897,14.215C17.584,13.903 17.16,13.727 16.718,13.727H10.045C9.602,13.727 9.178,13.903 8.865,14.215C8.552,14.528 8.377,14.953 8.377,15.395V22.068H5.04V5.386H8.377V8.722C8.377,9.165 8.552,9.589 8.865,9.902C9.178,10.215 9.602,10.391 10.045,10.391H16.718C17.16,10.391 17.584,10.215 17.897,9.902C18.21,9.589 18.386,9.165 18.386,8.722V5.728L21.722,9.064V22.068H18.386Z"
                                    id="path_0" />
                            </svg>
                        </a> -->
                        <!-- <a class="btn btn-sm btn-success d-flex align-items-center ms-r px-2" (click)="showManageRegularTablesPlanModal()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3" />
                              </svg>
                        </a> -->
                    }
                }

                @if (editMode || reservationAssignTablesMode || addJoinedTablesMode || assignCategoriesToTablesMode || isOnExcludeFromOnlineChannelsMode) {
                <a class="btn btn-sm btn-success menu-btn ms-r px-2 d-flex align-items-center" (click)="closeAssignTablesMode(true)" [class.disabled]="editMode && editingTable != null">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                </a>
                }
                @if (reservationAssignTablesMode || editMode || selectedTables.length > 0 || addJoinedTablesMode || assignCategoriesToTablesMode || isOnExcludeFromOnlineChannelsMode) {
                <a class="btn btn-sm btn-danger menu-btn ms-r px-2 d-flex align-items-center" (click)="closeAssignTablesMode(false)" [class.disabled]="editMode && editingTable != null">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24"
                        stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </a>
                }

                @if (isOnTablesPlanPage() && (date$ | async) && editMode) {
                    <!-- assign online category -->
                    @if (tablesMode == 'Tables' && !assignCategoriesToTablesMode && !isOnExcludeFromOnlineChannelsMode) {
                        <div class="dropdown ihost-dropdown assign-online-category-dropdown">
                            <a id="assignOnlineCategoryDropdown" #assignOnlineCategoryDropdown class="btn btn-sm btn-main menu-btn ms-r px-2 d-flex align-items-center" href="#" role="button" data-bs-toggle="dropdown"
                                data-bs-display="static" aria-expanded="false" [class.disabled]="editingTable != null" (click)="clickOnlineCategoriesButton()">
                                <svg id="vector" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 14 14">
                                    <path fill="#f8f8f8" fill-rule="evenodd"
                                        d="M13,1H1V13H13V1ZM1,0C0.448,0 0,0.448 0,1V13C0,13.552 0.448,14 1,14H13C13.552,14 14,13.552 14,13V1C14,0.448 13.552,0 13,0H1ZM4.25,11C4.94,11 5.5,10.44 5.5,9.75C5.5,9.06 4.94,8.5 4.25,8.5C3.56,8.5 3,9.06 3,9.75C3,10.44 3.56,11 4.25,11ZM4.25,12C5.493,12 6.5,10.993 6.5,9.75C6.5,8.507 5.493,7.5 4.25,7.5C3.007,7.5 2,8.507 2,9.75C2,10.993 3.007,12 4.25,12ZM11,9.75C11,10.44 10.44,11 9.75,11C9.06,11 8.5,10.44 8.5,9.75C8.5,9.06 9.06,8.5 9.75,8.5C10.44,8.5 11,9.06 11,9.75ZM12,9.75C12,10.993 10.993,12 9.75,12C8.507,12 7.5,10.993 7.5,9.75C7.5,8.507 8.507,7.5 9.75,7.5C10.993,7.5 12,8.507 12,9.75ZM4.25,5.5C4.94,5.5 5.5,4.94 5.5,4.25C5.5,3.56 4.94,3 4.25,3C3.56,3 3,3.56 3,4.25C3,4.94 3.56,5.5 4.25,5.5ZM4.25,6.5C5.493,6.5 6.5,5.493 6.5,4.25C6.5,3.007 5.493,2 4.25,2C3.007,2 2,3.007 2,4.25C2,5.493 3.007,6.5 4.25,6.5ZM11,4.25C11,4.94 10.44,5.5 9.75,5.5C9.06,5.5 8.5,4.94 8.5,4.25C8.5,3.56 9.06,3 9.75,3C10.44,3 11,3.56 11,4.25ZM12,4.25C12,5.493 10.993,6.5 9.75,6.5C8.507,6.5 7.5,5.493 7.5,4.25C7.5,3.007 8.507,2 9.75,2C10.993,2 12,3.007 12,4.25Z"
                                        id="path_0" />
                                </svg>
                            </a>
                            <div class="dropdown-menu tables-plan-menu p-0 border-0">
                                @for(onlineCategory of onlineCategories; track onlineCategory.id) {
                                    <a class="online-category btn btn-sm d-flex align-items-center align-content-center py-1 px-2 text-nowrap"
                                        (click)="setOnlineCategoryToAssign(onlineCategory)">
                                        <div class="btn-tag-group">
                                            <label [style.background-color]="onlineCategory.iconColor"
                                                class="d-flex justify-content-center align-items-center mb-0 btn-tag-static btn-tag-static-fixed fw-bold">
                                                {{onlineCategory.iconCaption}}
                                            </label>
                                        </div>
                                        <span class="ms-1">{{ onlineCategory.nameLocalized }}</span>
                                    </a>
                                }
                            </div>
                        </div>
                    }

                    <!-- exclude from online channels -->
                    @if (tablesMode == 'Tables' && !assignCategoriesToTablesMode && !isOnExcludeFromOnlineChannelsMode) {
                        <div class="dropdown ihost-dropdown exclude-from-online-channels-dropdown">
                            <a id="excludeFromOnlineChannelsDropdown" #excludeFromOnlineChannelsDropdown class="btn btn-sm btn-main menu-btn ms-r px-2 d-flex align-items-center" href="#" role="button" data-bs-toggle="dropdown"
                                data-bs-display="static" aria-expanded="false" [class.disabled]="editingTable != null">
                                <svg id="vector" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28">
                                    <path fill="#F8F8F8"
                                        d="M10.871,9.223H19.212V4.218C19.212,3.776 19.036,3.351 18.723,3.038C18.41,2.726 17.986,2.55 17.544,2.55H4.198C3.756,2.55 3.332,2.726 3.019,3.038C2.706,3.351 2.53,3.776 2.53,4.218V17.563C2.53,18.006 2.706,18.43 3.019,18.743C3.332,19.056 3.756,19.232 4.198,19.232H9.203V10.891C9.203,10.448 9.379,10.024 9.691,9.711C10.004,9.398 10.429,9.223 10.871,9.223Z"
                                        id="path_0" />
                                    <path fill="#F8F8F8"
                                        d="M24.216,9.223H19.212V17.563C19.212,18.006 19.036,18.43 18.723,18.743C18.41,19.056 17.986,19.232 17.544,19.232H9.203V24.236C9.203,24.678 9.379,25.103 9.691,25.416C10.004,25.729 10.429,25.904 10.871,25.904H24.216C24.659,25.904 25.083,25.729 25.396,25.416C25.709,25.103 25.885,24.678 25.885,24.236V10.891C25.885,10.448 25.709,10.024 25.396,9.711C25.083,9.398 24.659,9.223 24.216,9.223Z"
                                        id="path_1" />
                                </svg>
                            </a>
                            <div class="dropdown-menu tables-plan-menu p-0 border-0">
                                <a class="online-category btn btn-sm d-flex align-items-center align-content-center py-1 px-2 text-nowrap"
                                    (click)="excludeFromOnlineOwnChannels()">
                                    <img src="assets/images/excluded_from_own.png">
                                    <span class="ms-1">{{ 'tablesPlan.editMode.excludeFromOnLine' | translate }}</span>
                                </a>
                                <a class="online-category btn btn-sm d-flex align-items-center align-content-center py-1 px-2 text-nowrap"
                                    (click)="excludeFromOnlineThirdPartyChannels()">
                                    <img src="assets/images/excluded_from_tp.png">
                                    <span class="ms-1">{{ 'tablesPlan.editMode.excludeFromThirdParty' | translate }}</span>
                                </a>
                            </div>
                        </div>
                    }
                }

                @if (editMode && !addJoinedTablesMode && !assignCategoriesToTablesMode && !isOnExcludeFromOnlineChannelsMode) {
                    <!-- show manage regular tables plan modal -->
                    <a class="btn btn-sm btn-main d-flex align-items-center ms-r px-2 d-flex align-items-center" (click)="showManageRegularTablesPlanModal()"
                        [class.disabled]="editingTable != null">
                        <svg id="vector" xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 27 28">
                            <path fill="#f8f8f8"
                                d="M23.148,8.13L18.978,3.96C18.9,3.882 18.808,3.821 18.706,3.78C18.604,3.738 18.495,3.717 18.386,3.718H5.04C4.598,3.718 4.174,3.894 3.861,4.206C3.548,4.519 3.372,4.944 3.372,5.386V22.068C3.372,22.51 3.548,22.934 3.861,23.247C4.174,23.56 4.598,23.736 5.04,23.736H21.722C22.164,23.736 22.589,23.56 22.902,23.247C23.214,22.934 23.39,22.51 23.39,22.068V8.722C23.391,8.613 23.37,8.504 23.328,8.402C23.287,8.3 23.226,8.208 23.148,8.13ZM10.045,5.386H16.718V8.722H10.045V5.386ZM16.718,22.068H10.045V15.395H16.718V22.068ZM18.386,22.068V15.395C18.386,14.953 18.21,14.528 17.897,14.215C17.584,13.903 17.16,13.727 16.718,13.727H10.045C9.602,13.727 9.178,13.903 8.865,14.215C8.552,14.528 8.377,14.953 8.377,15.395V22.068H5.04V5.386H8.377V8.722C8.377,9.165 8.552,9.589 8.865,9.902C9.178,10.215 9.602,10.391 10.045,10.391H16.718C17.16,10.391 17.584,10.215 17.897,9.902C18.21,9.589 18.386,9.165 18.386,8.722V5.728L21.722,9.064V22.068H18.386Z"
                                id="path_0" />
                        </svg>
                    </a>
                }

                <!-- tables plan settings -->
                @if (!reservationAssignTablesMode && selectedTables.length <= 0 && !addJoinedTablesMode && !assignCategoriesToTablesMode && !isOnExcludeFromOnlineChannelsMode) { <div
                    class="dropdown ihost-dropdown h-100">
                    <a class="btn btn-sm btn-main ms-r px-2" href="#" role="button" data-bs-toggle="dropdown"
                        data-bs-display="static" aria-expanded="false" [class.disabled]="disableMenuItems()">
                        <app-icon icon="MenuDots"></app-icon>
                    </a>
                    <div class="dropdown-menu tables-plan-menu p-0 border-0">
                        @if (showSurname) {
                        <a class="btn btn-sm d-flex align-items-center align-content-center py-1 px-2 text-nowrap"
                            (click)="setShowSurname(false)">
                            <app-icon icon="Users"></app-icon>
                            <span class="ms-1">{{ 'tablesPlan.header.hideSurname' | translate }}</span>
                        </a>
                        } @else {
                        <a class="btn btn-sm d-flex align-items-center align-content-center py-1 px-2"
                            (click)="setShowSurname(true)">
                            <app-icon icon="Users"></app-icon>
                            <span class="ms-1">{{'tablesPlan.header.showSurname' | translate }}</span>
                        </a>
                        }
                        @if (showProgress) {
                        <a class="btn btn-sm d-flex align-items-center align-content-center py-1 px-2 text-nowrap"
                            (click)="setShowProgress(false)">
                            <app-icon icon="ProgressBar"></app-icon>
                            <span class="ms-1">{{ 'tablesPlan.header.hideProgress' | translate }}</span>
                        </a>
                        } @else {
                        <a class="btn btn-sm d-flex align-items-center align-content-center py-1 px-2"
                            (click)="setShowProgress(true)">
                            <app-icon icon="ProgressBar"></app-icon>
                            <span class="ms-1">{{'tablesPlan.header.showProgress' | translate }}</span>
                        </a>
                        }
                        @if (showTablesConnection) {
                        <a class="btn btn-sm d-flex align-items-center align-content-center py-1 px-2 text-nowrap"
                            (click)="setShowTablesConnection(false)">
                            <app-icon icon="TableConnections"></app-icon>
                            <span class="ms-1">{{ 'tablesPlan.header.hideTablesConnection' | translate }}</span>
                        </a>
                        } @else {
                        <a class="btn btn-sm d-flex align-items-center align-content-center py-1 px-2"
                            (click)="setShowTablesConnection(true)">
                            <app-icon icon="TableConnections"></app-icon>
                            <span class="ms-1">{{'tablesPlan.header.showTablesConnection' | translate }}</span>
                        </a>
                        }

                        <div class="shifts">
                            <hr style="width: 90%; margin: 0.5rem auto 0.25rem auto;">

                            @for (shift of processedShifts; track shift.shiftId) {
                            <a class="btn btn-sm py-1 px-2 text-nowrap d-flex justify-content-between"
                                (click)="selectTablesPlanShift(shift)"
                                [class.active]="shift.shiftId == selectedShift?.shiftId">
                                <span class="shift-name">{{getShiftTitle(shift.type)}}</span>
                                <span class="shift-hours">{{shift | shiftFromToHour}}</span>
                            </a>
                            }
                        </div>

                    </div>
            </div>
            }
        </div>
        }
</div>
</header>


<router-outlet class="main-router" #outlet="outlet"></router-outlet>


<div *ngIf="(isOffline$ | async) || (totalPendingActionsNumber > 0)" [class.bg-danger]="isOffline"
    [class.bg-success]="!isOffline" class="offline-footer d-flex justify-content-center align-items-center">
    <div class="text-white">{{isOffline ? 'Offline' : 'Online'}}: {{ 'offline.pendingActions' | translate }}
        {{totalPendingActionsNumber}}
    </div>
</div>
</div>

<app-modal-dialog #noConnectionModal title="{{ 'offline.noConnection' | translate }}!" modalId="no-connection-modal"
    okText="{{ 'common.ok' | translate }}" [isValid]="true" (onClose)="submitReservation($event)" [hasCancel]="false">
    <div class="form-col">
        <span>{{ 'offline.appWillTryLater' | translate }}...</span>
    </div>
</app-modal-dialog>

<app-modal-dialog #alertModal title="{{alert?.title}}" modalId="alert-modal" okText="{{ 'common.ok' | translate }}"
    [isValid]="true" [hasCancel]="false" [static]="true" (onClose)="onCloseAlert($event)">
    <div class="form-col">
        <p>{{alert?.template}}</p>
    </div>
</app-modal-dialog>

<app-modal-dialog #confirmationModal title="{{confirmation?.title}}" modalId="confirmation-modal"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasOk]="!confirmation?.hideConfirm" [hasCancel]="true"
    (onClose)="onCloseConfirmation($event)">
    <div class="form-col">
        <p>{{confirmation?.template}}</p>
    </div>
</app-modal-dialog>

<app-modal-dialog #doubleBookingConfirmationModal
    title="{{ confirmation?.title }}"
    modalId="doubleBookingConfirmationModal"
    okText="{{ 'common.buttons.continue' | translate }}"
    [isValid]="true"
    [hasCancel]="true"
    [hasOk]="confirmation?.hideConfirm !== true"
    dialogClass="modal-dialog-lg"
    (onClose)="onCloseConfirmation($event)">

    <div class="form-col">
    
        <div *ngIf="pendingConfirm === 'doubleBooking'; else defaultConfirmationMessage"
            class="double-booking-message text-center mb-4">
            <p>{{ 'reservations.doubleBooking.messageLine1' | translate }}</p>
    
            <p *ngIf="utilsService.canWrite('skipDoubleBooking')">
                {{ 'reservations.doubleBooking.messageLine2' | translate }}
            </p>
    
            <p *ngIf="utilsService.canWrite('skipDoubleBooking')">
                {{ 'reservations.doubleBooking.messageLine3' | translate }}
            </p>
        </div>

        <ng-template #defaultConfirmationMessage>
            <p>{{ confirmation?.template }}</p>
        </ng-template>

        <div *ngIf="pendingConfirm === 'doubleBooking' && doubleBookingConflictReservations.length > 0"
             class="double-booking-conflicts table-responsive">

            <table class="table table-sm double-booking-conflicts-table">
                <thead>
                    <tr>
                        <th>{{ 'reservations.doubleBooking.restaurant' | translate }}</th>
                        <th>{{ 'reservations.doubleBooking.customer' | translate }}</th>
                        <th>{{ 'reservations.doubleBooking.dateTime' | translate }}</th>
                        <th>{{ 'reservations.doubleBooking.covers' | translate }}</th>
                        <th>{{ 'reservations.doubleBooking.category' | translate }}</th>
                        <!-- <th [canWrite]="'SearchByRoomNum'" >{{ 'reservations.doubleBooking.roomNumber' | translate }}</th> -->
                        <th  >{{ 'reservations.doubleBooking.roomNumber' | translate }}</th>
                        <th>{{ 'reservations.doubleBooking.reservationId' | translate }}</th>
                        <!-- <th [canWrite]="'SearchByBookingId'" >{{ 'reservations.doubleBooking.roomBookingId' | translate }}</th> -->
                        <th  >{{ 'reservations.doubleBooking.roomBookingId' | translate }}</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let r of doubleBookingConflictReservations">
                        <td>{{ r.restaurantTitle }}</td>
                        <td>{{ (r.surname || '') + ' ' + (r.name || '') }}</td>
                        <td>{{ r.arrivalAt || '-' | date:'dd/MM/yyyy HH:mm' }}</td>
                        <td>{{ r.covers }}</td>
                        <td>{{ getDoubleBookingCategoryName(r) }}</td>
                        <!-- <td [canWrite]="'SearchByRoomNum'">{{ r.roomNumber || '-' }}</td> -->
                        <td >{{ r.roomNumber || '-' }}</td>
                        <td>{{ r.id || '-' }}</td>
                        <!-- <td [canWrite]="'SearchByBookingId'">{{ r.roomBookingID || '-' }}</td> -->
                        <td >{{ r.roomBookingID || '-' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</app-modal-dialog>

<app-modal-dialog #deleteJoinedTablesConfirmationModal title="{{confirmation?.title}}" modalId="delete-joined-tables-confirmation-modal"
    okText="{{ 'common.yes' | translate }}" cancelText="{{ 'common.no' | translate }}" [isValid]="true" [hasCancel]="true"
    (onClose)="onCloseDeleteJoinedTablesConfirmation($event)">
    <div class="form-col">
        @if (joinedTablesToDelete.length > 1) {
            <p>{{ 'tablesPlan.editMode.deleteJoinTablesWarningMessage' | translate:{tables:joinedTableNamesToDelete} }}</p>
        } @else {
            <p>{{ 'tablesPlan.editMode.deleteJoinTablesWarningMessage_One' | translate:{table:joinedTableNamesToDelete} }}</p>
        }
    </div>
</app-modal-dialog>

<app-modal-dialog #serviceWarningModal [static]="true"
    title="{{ (stopService ? 'messages.serviceStopTitle' : 'messages.serviceWarningTitle') | translate }}"
    [modalId]="'no-payment-warning'" [hasCancel]="false" [hasClose]="false" okText="OK">
    <div class="form-col">
        <p [innerHtml]="((stopService ? 'messages.serviceStopDetails' : 'messages.serviceWarningDetails') | translate)
                        .replace('{DATE}', (stopServiceDate | date: 'dd-MM-yyyy'))">
        </p>
    </div>
</app-modal-dialog>

<app-modal-dialog #advertismentModal [static]="false" title="{{advertismentTitle}}"
    [modalId]="'advertisment-modal'" [hasCancel]="false" [hasClose]="true" [hasOk]="false">
    <div class="form-col">
        <img class="promo-img" [src]="advertisment?.picture">
        <div class="promo-content" [innerHTML]="advertismentDesc">
        </div>
        <a class="btn-success btn readmore-btn" 
            *ngIf="advertismentUrl && advertismentUrl != ''" 
            (click)="onAdsClick()" 
            [href]="advertismentUrl"
            target="_blank">{{advertismentCta}}</a>
    </div>
</app-modal-dialog>

<app-modal-dialog #alreadyReservedTablesModal title="{{'common.warning' | translate }}"
    modalId="alreadyReservedTables-modal" [isValid]="true" [hasCancel]="false" [hasOk]="false" [hasClose]="false"
    [static]="true" (onClose)="onCloseConfirmation($event)">
    <div class="form-col">
        @if (conflictedAllocatedTables != null && conflictedAllocatedTables.length > 0) {
        @if (conflictedAllocatedTables.length == 1) {
        <p>
            <span>{{'tablesPlan.alreadyReservedModal.messageSinglePart1' | translate }}</span>
            <b> {{conflictedAllocatedTableNames}} </b>
            <span>{{'tablesPlan.alreadyReservedModal.messageSinglePart2' | translate }}</span>
        </p>
        } @else {
        <p>
            <span>{{'tablesPlan.alreadyReservedModal.messagePluralPart1' | translate }}</span>
            <b> {{conflictedAllocatedTableNames}} </b>
            <span>{{'tablesPlan.alreadyReservedModal.messagePluralPart2' | translate }}</span>
        </p>
        }
        }
        <div class="already-reserved-tables-modal-buttons d-flex justify-content-between flex-wrap mt-5">
            <button type="button" class="w-sm-full btn btn-main" (click)="manageTables()">
                {{ 'tablesPlan.alreadyReservedModal.manageTablesBtn' | translate }}
            </button>
            <div class="d-flex justify-content-between w-sm-full">
                <button type="button" class="w-sm-50 btn btn-faded mt-2" (click)="cancelAssignTables()">
                    {{ 'common.buttons.cancel' | translate }}
                </button>
                <button type="button" class="w-sm-50 btn btn-main mt-2" (click)="confirmAssignReservedTables()">
                    {{ 'common.buttons.continue' | translate }}
                </button>
            </div>
        </div>
    </div>
</app-modal-dialog>

<app-modal-dialog #manageReservedTablesModal title="{{'common.warning' | translate }}"
    modalId="manageReservedTables-modal" [hasCancel]="false" [hasOk]="false" [hasClose]="false" [static]="true"
    (onClose)="onCloseConfirmation($event)">
    <div class="form-col">
        @if (conflictedAllocatedTables != null && conflictedAllocatedTables.length > 0) {
        <p>
            <b>{{'tablesPlan.manageReservedModal.manage' | translate }}</b>
            @if (conflictedAllocatedTables.length == 1) {
            <span> {{'tablesPlan.manageReservedModal.table' | translate }} </span>
            } @else {
            <span> {{'tablesPlan.manageReservedModal.tables' | translate }} </span>
            }
            <b>{{conflictedAllocatedTableNames}}</b>.
        </p>
        }
        <div
            [class]="'d-flex ' + (conflictingReservations.length <= 1 ? 'justify-content-between' : 'justify-content-end')">
            @if (conflictingReservations.length <= 1) { <button type="button" class="btn btn-main mt-5"
                (click)="swapTables()">
                {{ 'tablesPlan.manageReservedModal.swapTablesBtn' | translate }}
                </button>
                }

                <div class="d-flex">
                    <button type="button" class="btn btn-faded mt-5" (click)="cancelManageTables()">
                        {{ 'common.buttons.cancel' | translate }}
                    </button>
                    <button type="button" class="btn btn-main mt-5" (click)="getReservedTables()">
                        {{ 'tablesPlan.manageReservedModal.getTablesBtn' | translate }}
                    </button>
                </div>
        </div>
    </div>
</app-modal-dialog>

<!-- order details -->
<app-order-details #orderDetailsModal></app-order-details>

<app-modal-dialog #helpModal [static]="false" title="{{'help.title' | translate }}" [modalId]="'help-modal'"
    [hasCancel]="false" [hasClose]="true" [hasOk]="false">
    <div class="form-col">
        <p><span>{{'help.tel' | translate }}</span>&nbsp;<b><a href="tel:+302102207079" target="_blank">+30 210 220 70
                    79</a></b></p>
        <p>Email: <b><a href="mailto:support@i-host.gr" target="_blank">support&#64;i-host.gr</a></b></p>
        <p>Version: <b>{{ver}}</b></p>
    </div>
</app-modal-dialog>

<!-- manage regular tables plan -->
<app-modal-dialog #manageRegularTablesPlanModal [static]="false" title="{{'tablesPlan.manageRegularTablesPlanModal.title' | translate }}"
    [modalId]="'manageRegularTablesPlan-modal'" [hasCancel]="false" [hasClose]="true" [hasOk]="false">
    <div class="form-col">
        <p>
            <span>{{ 'tablesPlan.manageRegularTablesPlanModal.message' | translate }} </span>
            <b>{{ date | amLocale:'el' | amDateFormat:'dddd DD-MM-yyyy' }}</b>
        </p>

        <div class="d-flex justify-content-between flex-wrap gap-4 mt-5">
            <div class="d-flex flex-grow-1">
                <button type="button" class="btn btn-main w-100" (click)="restoreRegularTablesPlan()">
                    {{ 'tablesPlan.manageRegularTablesPlanModal.restoreRegularButton' | translate }}
                </button>
            </div>
            <div class="d-flex gap-4 flex-grow-1">
                <button type="button" class="btn flex-grow-1 btn-faded" (click)="cancelManageRegularTablesPlan()">
                    {{ 'common.buttons.cancel' | translate }}
                </button>
                <button type="button" class="btn flex-grow-1 btn-main" (click)="saveTablesPlanAsRegular()">
                    {{ 'tablesPlan.manageRegularTablesPlanModal.saveAsRegularButton' | translate }}
                </button>
            </div>
        </div>
    </div>
</app-modal-dialog>

<!-- settings -->
<app-modal-dialog #settingsModal [static]="false" title="{{'tablesPlan.settings.title' | translate }}"
    [modalId]="'tablesPlanSettings-modal'" [hasCancel]="false" [hasClose]="false" [hasOk]="false">
    <div class="form-col">
        <app-settings (hide)="hideSettingsModal()"></app-settings>
    </div>
</app-modal-dialog>

<!-- reservations export -->
<app-modal-dialog #reservationsExportModal [static]="false"
    title="{{ 'reservationsExport.title' | translate }}"
    [modalId]="'reservationsExport-modal'"
    [hasCancel]="false"
    [hasClose]="false"
    [hasOk]="false">
    <div class="form-col">
        <app-reservations-export
            [reservations]="reservationsToExport"
            [selectedShift]="selectedShift ?? null"
            [selectedShiftTitle]="selectedShiftTitleForExport"
            [selectedDate]="date"
            [restaurantTitle]="restaurantTitleForExport"
            (hide)="hideReservationsExportModal()">
        </app-reservations-export>
    </div>
</app-modal-dialog>

<app-modal-dialog #notAvailableTablesConfirmationOnSubmitModal title="{{'common.alert' | translate}}" modalId="notAvailableTables-confirmation-onsubmit-modal"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true"
    (onClose)="onCloseNotAvailableTablesConfirmationOnSubmit($event)">
    <div class="form-col">
        <span>{{ 'reservations.validationMessages.notAvailableTables' | translate: {tables: notAvailableTableNames}
            }}</span>
    </div>
</app-modal-dialog>

<div #toast class="toast position-fixed bottom-0 start-50 translate-middle-x text-bg-danger z-2" role="alert" aria-live="assertive" aria-atomic="true"
    data-bs-config='{"delay":2500, "autohide": true, "animation": true}'>
    <div class="toast-body text-center">
      <p>{{validationMessage}}</p>
    </div>
</div>

<app-toast></app-toast>

<ngx-spinner type="square-jelly-box"></ngx-spinner>